export const it = {
  pwa: {
    update: "Aggiorna",
    updateDescription: "È stato rilevato un nuovo aggiornamento dell'app",
    updateTitle: "Aggiornamento disponibile",
  },
};
